import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import CookbookFilterDataQuery from './CookbookFilterDataQuery';
import { CookbookFilterDataQueryResult, CookbookFilterMeal, CookbookFilterTag } from '../types';

type result = {
  loading: boolean;
  error?: ApolloError;
  calorieRanges?: number[];
  mealTypeTags?: CookbookFilterTag[];
  dietTypeTags?: CookbookFilterTag[];
  customTags?: CookbookFilterTag[];
  filterMeals?: CookbookFilterMeal[];
};

interface ICookbookFilterDataConnectorApollo {
  children: (result: result) => React.ReactElement;
}

/**
 * Fetches everything the cookbook filter screen needs to render in one request: the options of
 * every filter group and the facet values of all published meals, used to disable options that
 * would lead to an empty result.
 */
const CookbookFilterDataConnectorApollo: React.FC<ICookbookFilterDataConnectorApollo> = ({
  children,
}) => {
  const { loading, error, data } = useQuery<CookbookFilterDataQueryResult>(CookbookFilterDataQuery);

  const result: result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading && data) {
    const { tags, filterData } = data.cookbook;

    result.calorieRanges = tags.calorieRanges;
    result.mealTypeTags = tags.mealTypeTags ?? [];
    result.dietTypeTags = tags.dietTypeTags ?? [];
    result.customTags = tags.customTags ?? [];
    result.filterMeals = filterData.meals;
  }

  return children(result);
};

export default CookbookFilterDataConnectorApollo;
